// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"650":"LocaleMessageModal","680":"LocaleMessageContent"}[chunkId] + "." + {"650":"728159a5a06b827259c5","680":"7cc1098494fd11f8b114"}[chunkId] + ".js";
};